module.exports = __webpack_public_path__ + "img/asset_delete_white.c599da7a.svg";